<template>
  <router-view />
</template>

<style lang="scss">
@import "./assets/base.css";

#app {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;

  font-weight: normal;

  h1,
  h2,
  h3,
  h4 {
    font-weight: bold;
    color: var(--color-heading);
  }

  button {
    padding: 0.5rem;
    margin: 0 0.5rem;
    border: none;
    background-color: var(--vt-c-green);
    border-radius: 0.25rem;
    transition: 0.3s ease;
    cursor: pointer;

    &:hover {
      background-color: var(--vt-c-green-dark);
    }
  }

  input {
    background-color: transparent;
    color: var(--vt-c-white);
    margin: 0.75rem 0 0.5rem 0;
    padding: 0.75rem 0 0.5rem 0;
    border: none;
    border-bottom: 1px solid var(--vt-c-green);

    &:focus-visible {
      outline: none;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    &[type="number"] {
      appearance: textfield;
      -moz-appearance: textfield;
    }
  }
}

@media (hover: hover) {
  a:hover {
    background-color: hsla(160, 100%, 37%, 0.2);
  }
}

@media (min-width: 1024px) {
  /* body {
    display: flex;
    place-items: center;
  } */

  /* #app {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 2rem;
  } */
}
</style>
